import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { FaBolt, FaArrowRight } from 'react-icons/fa';
import { computeCatalogActivationMetrics } from '../../../utils/masterCatalogProduct';

export default function CatalogActivationMetrics({ productos, metrics: metricsProp, compact = false, showBulkLink = true }) {
  const metrics = useMemo(
    () => metricsProp || computeCatalogActivationMetrics(productos),
    [productos, metricsProp]
  );

  if (metrics.total === 0) return null;

  const barWidth = `${Math.min(100, metrics.porcentaje)}%`;

  if (compact) {
    return (
      <div className="rounded-lg border border-indigo-100 bg-indigo-50/80 px-3 py-2 text-sm" title="Catálogo importado 0E3">
        <span className="font-medium text-indigo-900">Catálogo activado: </span>
        <span className="text-indigo-800">
          {metrics.activados} / {metrics.total} ({metrics.porcentaje}%)
        </span>
        {metrics.pendientes > 0 && (
          <span className="ml-2 text-orange-700">· {metrics.pendientes} pendientes</span>
        )}
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-sm font-semibold text-slate-800">Activación catálogo importado</p>
          <p className="mt-1 text-2xl font-bold text-slate-900">
            {metrics.activados} / {metrics.total}
            <span className="ml-2 text-base font-semibold text-indigo-600">{metrics.porcentaje}%</span>
          </p>
          <div className="mt-2 h-2 w-full max-w-md overflow-hidden rounded-full bg-slate-100">
            <div
              className="h-full rounded-full bg-gradient-to-r from-orange-400 via-yellow-400 to-green-500 transition-all"
              style={{ width: barWidth }}
            />
          </div>
        </div>
        <div className="flex flex-wrap gap-4 text-sm">
          <div>
            <span className="inline-block h-2 w-2 rounded-full bg-orange-500 mr-1" />
            Pendientes: <strong>{metrics.pendientes}</strong>
          </div>
          <div>
            <span className="inline-block h-2 w-2 rounded-full bg-yellow-500 mr-1" />
            Sin stock: <strong>{metrics.sinStock}</strong>
          </div>
          <div>
            <span className="inline-block h-2 w-2 rounded-full bg-green-500 mr-1" />
            Listos: <strong>{metrics.listos}</strong>
          </div>
        </div>
        {showBulkLink && metrics.pendientes > 0 && (
          <Link
            to="/productos/activacion-masiva"
            className="inline-flex items-center gap-2 rounded-lg bg-orange-600 px-4 py-2 text-sm font-semibold text-white hover:bg-orange-700"
          >
            <FaBolt />
            Carga masiva
            <FaArrowRight className="text-xs" />
          </Link>
        )}
      </div>
    </div>
  );
}
